<meta-title i18n>הודעה נשלחה אליך במייל</meta-title>

<div class="auth-page">
  <header class="auth-page-header">
    <h2 i18n>שלחנו לך בדוא"ל קישור לאיפוס הסיסמה שלך</h2>
    <p i18n>זיהינו אותך בהצלחה — בדקו את תיבת הדוא"ל שלכם להמשך</p>
  </header>

  <div class="auth-card">
    <p i18n>
      שלחנו לך בדוא"ל שאיתו נרשמת קישור לאיפוס סיסמה.
    </p>

    <p [hidden]="!showEmailAddress" i18n>
      כתובת הדוא"ל שלך המעודכנת במערכת היא:
      <span dir="ltr">{{ emailAddress }}</span>
    </p>

    <p i18n>
      לאחר הכניסה לקישור תקבל סיסמה חדשה שאיתה תוכל להכנס למערכת.
    </p>

    <p i18n>
      בברכה,
      <br />
      מערכות מידע
    </p>

    <div class="auth-form-actions">
      <button type="button" class="auth-secondary-btn" (click)="goBack()" i18n>
        חזרה להתחברות
      </button>
    </div>
  </div>
</div>
